import React from "react";
import { Container, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: "3vw",
    [theme.breakpoints.down("sm")]: {
      fontSize: "6vw",
    },
    [theme.breakpoints.between("sm", "md")]: {
      fontSize: "5vw",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "3vw",
    },
  },
}));

const SvgContainer = ({ title = "Title", image, mappingArray }) => {
  // console.log(mappingArray);
  const classes = useStyles();
  return (
    <Container>
      <Grid item xs={12}>
        <Typography variant="h4" align="center" className={classes.title}>
          {title}
        </Typography>
      </Grid>
      <div>
        <svg
          viewBox="0 0 500 300"
          preserveAspectRatio="xMidYMid meet"
          xmlns="http://www.w3.org/2000/svg"
        >
          <image href={image} width="500" height="300" />
          {mappingArray?.map((item) => {
            if (item.type === "text") {
              return (
                <text
                  x={item.xAxis}
                  y={item.yAxis}
                  font-family="Arial"
                  font-size={item.fontSize || 10}
                  fill={item.textColor || "black"}
                  fontWeight="500"
                >
                  {item.body}
                </text>
              );
            }
            if (item.type === "rect") {
              return (
                <>
                  <rect
                    x={item.xAxis}
                    y={item.yAxis}
                    width={item.width}
                    height={item.height}
                    rx={item.radiusX}
                    ry={item.radiusY}
                    fill={item.color}
                    stroke={item.stroke || null}
                    stroke-width={item.strokeWidth || null}
                    stroke-linecap={item.lineCap || null}
                  />
                </>
              );
            }
            if (item.type === "svg") {
              return <svg x="400" y="0" width="400" height="300"></svg>;
            }
            if (item.type === "image") {
              return (
                <>
                  <image
                    href={item.body}
                    x={item.xAxis}
                    y={item.yAxis}
                    width={item.width}
                    height={item.height}
                    fill={item.fillColor}
                  />
                  {item.text && (
                    <text
                      x={item.xAxis + 2}
                      y={item.yAxis - 2}
                      font-family="Arial"
                      font-size="6"
                      fill="black"
                      fontWeight="500"
                    >
                      {item.text}
                    </text>
                  )}
                </>
              );
            }
          })}
        </svg>
      </div>
    </Container>
  );
};

export default SvgContainer;
